const getAPIURL = () => {
    return process.env.NODE_ENV === "production" ? "https://musicapi.912jams.com" : "http://localhost:3001";
}

export { getAPIURL };